import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import * as loginActions from "../../slices/auth/login.slice";
import { http } from "utils/http";
import { endPoint } from "constants/server/api";
export var login = function(payload, navigation, param) {
    var modalObj = param.modalObj, setModalObj = param.setModalObj;
    return function() {
        var _ref = _async_to_generator(function(dispatch) {
            var config, result, error, statusCode, errorMessage;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dispatch(loginActions.fetchData());
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        config = {
                            method: "post",
                            url: endPoint.LOGIN_URL,
                            data: payload
                        };
                        return [
                            4,
                            http(config)
                        ];
                    case 2:
                        result = _state.sent();
                        dispatch(loginActions.fetchDataSuccess(result.data));
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        statusCode = 500;
                        errorMessage = "เกิดข้อผิดพลาด";
                        if (http.isAxiosError(error) && error.response) {
                            statusCode = error.response.status;
                            errorMessage = error.response.data.message;
                        }
                        setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                            visible: true,
                            subTitle: "รหัส ".concat(statusCode),
                            navigateDirection: undefined,
                            title: errorMessage
                        }));
                        dispatch(loginActions.fetchDataFailure());
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
